import axios from 'axios';
import { ICirStoreCollection, ICirWeekCollection } from 'common/models/commonModel';
import {
  IImproveQscFindingsCollection,
  IImproveQscFindingsCollectionParams,
  IImproveQscStoreCardsCollection,
  IImproveQscStoreCardsCollectionParams,
  IImproveQscSummaryModel,
  IImproveQscSummaryParams,
} from 'entities/ImproveQsc/ImproveQsc.models';

const basePath = '/cir-portal/improve-qsc';

export const improveQscTransport = {
  getStores: (): Promise<ICirStoreCollection> => axios.get(`${basePath}/stores`),
  getWeeks: (): Promise<ICirWeekCollection> => axios.get(`${basePath}/weeks`),
  getSummary: (params?: IImproveQscSummaryParams): Promise<IImproveQscSummaryModel> =>
    axios.get(`${basePath}/summary`, { params }),
  getFindings: (params?: IImproveQscFindingsCollectionParams): Promise<IImproveQscFindingsCollection> =>
    axios.get(`${basePath}/findings`, { params }),
  getStoreCards: (params?: IImproveQscStoreCardsCollectionParams): Promise<IImproveQscStoreCardsCollection> =>
    axios.get(`${basePath}/store-cards`, { params }),
};
